var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 522.974,
    height: 508.472,
    viewBox: "0 0 522.974 508.472",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "face",
    "data-name": "Group 1046",
    transform: "translate(-52.362 -175.764)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2111",
    "data-name": "Path 2111",
    d: "M603.68,160.16c-19.039-24.641-61.6-7.281-85.68,7.84a122.53,122.53,0,0,0-11.762-12.32c9.52-1.121,18.48-3.922,23.52-12.32,2.238-4.48,2.8-10.078,0-14-5.039-7.84-14-10.641-22.961-12.879,14.559-10.078,29.121-26.879,14-41.441-6.719-6.16-18.48-8.961-27.441-8.961h-1.68c6.16-7.281,10.078-15.68,7.281-25.2-7.281-25.2-44.238-11.2-61.039-7.281A372.22,372.22,0,0,0,354.48,63.841c3.922-11.2,2.238-23.52-10.641-30.8C326.48,22.4,309.12,33.6,298.48,47.6,292.32,56,285.039,65.524,280,76.161a35.544,35.544,0,0,0-3.359-10.078c-7.281-14-23.52-19.6-37.52-12.32-14.559,7.281-19.6,23.52-17.922,38.641.559,3.359.559,7.281,1.121,11.2-24.078-.559-122.08-3.359-99.121,38.641,4.48,8.4,14.559,12.32,25.2,14-5.039,6.16-6.719,13.441-2.8,21.281,6.16,12.879,16.238,15.68,26.879,14a193.014,193.014,0,0,0-16.238,53.762C126,243.041,89.6,249.763,87.922,286.162c-1.121,33.6,30.238,41.441,57.68,40.879,11.2,126.56,118.72,234.64,252,201.6,98.559-24.641,168-113.68,183.12-211.12a11.283,11.283,0,0,0,1.68-6.16c.559-6.16.559-11.762.559-17.922a229.855,229.855,0,0,0-1.68-48.16,28.069,28.069,0,0,0-2.8-7.281c21.84-17.918,44.238-52.637,25.2-77.836ZM554.4,220.64a13.871,13.871,0,0,0-6.16,15.68,248.109,248.109,0,0,1,7.281,52.641c-5.039,90.16-59.918,176.4-147.84,207.2-125.44,43.68-231.28-61.6-235.2-184.24-.559-10.078-8.4-15.121-17.922-13.441-6.719,1.121-14,2.238-20.719,1.68-15.121,0-19.039-5.039-12.32-15.68,4.48-19.6,27.441-13.441,42.559-10.641,9.52,1.68,17.359-3.922,17.922-13.441a157.32,157.32,0,0,1,32.48-85.121,16.45,16.45,0,0,0,10.641,3.922c9.52.559,14.559-5.039,18.48-12.879a26.921,26.921,0,0,0,15.121,6.719c21.84,3.922,34.16-12.879,30.238-32.48a107.384,107.384,0,0,0,17.359,10.078c10.641,5.039,30.8,11.762,39.762.559,9.52-12.32,2.238-22.961-9.52-31.359,34.16,6.16,67.2,24.641,101.92,17.359,25.2,15.121,50.4,35.281,66.641,58.238a18.561,18.561,0,0,0,7.84,5.6,11.116,11.116,0,0,0,6.16.559,16.646,16.646,0,0,0,11.2-6.719c12.32-8.961,35.281-22.4,45.359-17.359,19.035,10.086-11.762,37.523-21.285,43.125Z",
    transform: "translate(-35.531 149.58)",
    fill: "#00469a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eyes",
    "data-name": "Group 1045"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2114",
    "data-name": "Path 2114",
    d: "M269.36,232.96c-17.922,0-17.922,28,0,28s17.922-28,0-28Z",
    transform: "translate(-35.531 149.58)",
    fill: "#00469a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2115",
    "data-name": "Path 2115",
    d: "M486.64,219.52c-17.922,0-17.922,28,0,28S505.12,219.52,486.64,219.52Z",
    transform: "translate(-35.531 149.58)",
    fill: "#00469a"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2116",
    "data-name": "Path 2116",
    d: "M398.72,308.56c-5.039,6.16-11.762,15.68-20.719,15.68-7.84,0-16.8-7.281-22.961-11.762-14.559-10.641-28.559,13.441-14,24.078,11.762,8.4,25.762,16.8,40.879,15.68,15.68-1.68,26.879-12.32,36.4-24.078,11.762-13.438-7.836-33.6-19.6-19.6Z",
    transform: "translate(-35.531 149.58)",
    fill: "#00469a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2117",
    "data-name": "Path 2117",
    d: "M396.48,183.68c-1.121-17.922-29.121-17.922-28,0,.559,14,1.121,28,1.121,41.441,0,10.078,1.121,22.961,0,34.16-10.641,1.68-22.4.559-31.922,0-17.922-1.121-17.922,26.879,0,28,16.8,1.121,53.2,6.719,58.238-16.238,6.16-26.883,1.684-59.922.563-87.363Z",
    transform: "translate(-35.531 149.58)",
    fill: "#00469a"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFace);
export default __webpack_public_path__ + "static/media/face.125b2e5be6749eac017bd6735a8cbd84.svg";
export { ForwardRef as ReactComponent };